import DashboardTwoToneIcon from '@material-ui/icons/DashboardTwoTone';
import PermIdentityTwoTone from '@material-ui/icons/PermIdentityTwoTone';
import PostAddTwoToneIcon from '@material-ui/icons/PostAddTwoTone';
import GroupTwoToneIcon from '@material-ui/icons/GroupTwoTone';
import HomeWorkTwoToneIcon from '@material-ui/icons/HomeWorkTwoTone';
import ScheduleTwoToneIcon from '@material-ui/icons/ScheduleTwoTone';
import SupervisorAccountTwoToneIcon from '@material-ui/icons/SupervisorAccountTwoTone';
import SubscriptionsTwoToneIcon from '@material-ui/icons/SubscriptionsTwoTone';
import AccountBoxTwoToneIcon from '@material-ui/icons/AccountBoxTwoTone';
import ExitToAppTwoToneIcon from '@material-ui/icons/ExitToAppTwoTone';
import ReceiptTwoToneIcon from '@material-ui/icons/ReceiptTwoTone';
import {ROLE_TYPE, MENU_LABEL} from 'eebac/constants';
import {ROUTES_PATH_CONFIG} from 'eebac/config/routes';

export default {
    [ROLE_TYPE.COMPANY]: {
        label: MENU_LABEL,
        content: [
                    {
                      "label": "Dashboard",
                      "icon": DashboardTwoToneIcon,
                      "to": ROUTES_PATH_CONFIG.COMPANY.dashboard
                    },
                    {
                        "label": "Works",
                        "icon": HomeWorkTwoToneIcon,
                        "open" : true,
                        "content" : [
                            {
                                "label": "Contractors",
                                "icon": PermIdentityTwoTone,
                                "to": "/c/contractors"
                            },
                            {
                                "label": "Posts",
                                "icon" : PostAddTwoToneIcon,
                                "to": "/c/work_posts"
                            },
                            {
                                "label": "RFQ",
                                "icon" : ReceiptTwoToneIcon,
                                "to": "/c/rfq"
                            },
                            {
                                "label": "Meeting Schedules",
                                "icon" : ScheduleTwoToneIcon,
                                "to": "/c/meeting_schedules"
                            }
                        ]
                    },
                    {
                        "label": "Jobs",
                        "icon": GroupTwoToneIcon,
                        "hidden" : true,
                        "content" : [
                            {
                                "label": "Job seeker",
                                "icon": PermIdentityTwoTone,
                                "to": "/c/job_seeker"
                            },
                            {
                                "label": "Posts",
                                "icon" : PostAddTwoToneIcon,
                                "to": "/c/job_posts"
                            },
                            {
                                "label": "Interview Schedules",
                                "icon" : ScheduleTwoToneIcon,
                                "to": "/c/interview_schedules"
                            }
                        ]
                    },
                    {
                        "label": "Account",
                        "icon": AccountBoxTwoToneIcon,
                        "showInUserBox" : true,
                        "content" : [
                            {
                                "label": "Subscription",
                                "icon": SubscriptionsTwoToneIcon,
                                "to": "/c/subscription"
                            },
                            {
                                "label": "Profile",
                                "icon" : AccountBoxTwoToneIcon,
                                "to": ROUTES_PATH_CONFIG.COMPANY.profile
                            },
                            {
                                "label": "Users",
                                "icon" : SupervisorAccountTwoToneIcon,
                                "to": "/c/users"
                            },
                            {
                                "label": "Sign Out",
                                "icon" : ExitToAppTwoToneIcon,
                                "to": ROUTES_PATH_CONFIG.APP.signout
                            }
                        ]

                    }
            ]
    },
    [ROLE_TYPE.COMPANY_CONTRACTS]: {
        label: MENU_LABEL,
        content: [
                    {
                      "label": "Dashboard",
                      "icon": DashboardTwoToneIcon,
                      "to": ROUTES_PATH_CONFIG.COMPANY.dashboard
                    },
                    {
                        "label": "Works",
                        "icon": HomeWorkTwoToneIcon,
                        "open" : true,
                        "content" : [
                            {
                                "label": "Contractors",
                                "icon": PermIdentityTwoTone,
                                "to": "/c/contractors"
                            },
                            {
                                "label": "Posts",
                                "icon" : PostAddTwoToneIcon,
                                "to": "/c/work_posts"
                            },
                            {
                                "label": "RFQ",
                                "icon" : ReceiptTwoToneIcon,
                                "to": "/c/rfq"
                            },
                            {
                                "label": "Meeting Schedules",
                                "icon" : ScheduleTwoToneIcon,
                                "to": "/c/meeting_schedules"
                            }
                        ]
                    },
                    {
                        "label": "Account",
                        "icon": AccountBoxTwoToneIcon,
                        "showInUserBox" : true,
                        "open" : true,
                        "content" : [
                            {
                                "label": "Profile",
                                "icon" : AccountBoxTwoToneIcon,
                                "to": ROUTES_PATH_CONFIG.COMPANY.profile
                            },
                            {
                                "label": "Sign Out",
                                "icon" : ExitToAppTwoToneIcon,
                                "to": ROUTES_PATH_CONFIG.APP.signout
                            }
                        ]

                    }
            ]
    }
};
